import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeSendSignal extends Shape {
    width = 200;
    height = 126;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 7) / 8 - 2 * horizontalPadding;
        const allowedHeight = (height * 5) / 8 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, height / 5, null);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        let r = h / 150;
        if (w < 2 * r) r = w / 2;

        const nose = w * 0.23;
        const rightX = x + w - nose; // Вертикальная линия перед стрелкой

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(rightX, y, x + w, y + h / 2, r);
        canv.ctx.arcTo(x + w, y + h / 2, rightX, y + h, r);
        canv.ctx.arcTo(rightX, y + h, x, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y, r);
        canv.ctx.arcTo(x, y, rightX, y, r);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="m1 5v14h16.7944l5.2056-7.0264-5.2056-6.97359z" stroke="${stroke}" stroke-linejoin="round"/>
            </svg>
        `;
    }
}
